<template>
  <section class="container relative z-10">
    <FormKit v-slot="{ disabled, state: { loading } }" v-model="loginDetails" type="form" form-class="mb-6" :actions="false" @submit="submitHandler">
      <ul class="w-full">
        <li>
          <h1 class="mb-2 text-xl font-bold leading-tight uppercase">{{ t_('title') }}</h1>
          <p class="mb-4 leading-snug sm:font-semibold md:mb-6 md:text-lg">{{ t_('introduction') }}</p>

          <ul>
            <!-- row -->
            <li class="mb-2 py-2">
              <ul class="grid gap-6">
                <li>
                  <FormKit
                    autocomplete="username"
                    type="text"
                    name="email"
                    :placeholder="t_('username-placeholder')"
                    validation="required:trim|email|length:4,50"
                    :label="t_('username')"
                  />
                </li>
              </ul>
            </li>
            <li class="mb-2 py-2">
              <ul class="grid gap-6">
                <li>
                  <FormKit
                    autocomplete="current-password"
                    type="password"
                    name="password"
                    :placeholder="t_('password-placeholder')"
                    validation="required:trim|length:4,255"
                    :label="t_('password')"
                  />
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          <FormKitMessages />
        </li>
        <li>
          <FormKit type="submit" :disabled="loading || disabled" outer-class="group inline-block">
            {{ t_('login') }}
            <AtomIcon
              :icon="loading || disabled ? 'app-loader' : 'arrow-right'"
              class="ml-8 w-5 h-5"
              :class="{ 'transform group-hover:translate-x-1 transition duration-200': !(loading || disabled) }"
            />
          </FormKit>
        </li>
      </ul>
    </FormKit>
  </section>
</template>

<script setup lang="ts">
import { FormKitMessages } from '@formkit/vue'
import { setupTranslationPrefixer } from '~/composables/util'
import { setupUser } from '~/composables/user'

const { t_ } = setupTranslationPrefixer('UserLoginForm')

const { login } = setupUser()

const submitHandler = async (data: object, node: any) => {
  // Clear errors and successes before saving
  node.clearErrors()

  if (!(await login(data))) {
    node.setErrors([t_('generic-error')])
  }
}
</script>
